import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformationService} from "../../services/information.service";
import {Subject, takeUntil} from "rxjs";
import {environment} from "../../../environments/environment";
import {  SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'product-back-info',
  templateUrl: './product-back-info.component.html',
  styleUrls: ['./product-back-info.component.less']
})
export class ProductBackInfoComponent implements OnInit, OnDestroy{

  addressLink: SafeHtml;
  shopAddress: SafeHtml;
  booksReturn: SafeHtml;

  private destroySubject: Subject<void> = new Subject();

  constructor(
    private informationService: InformationService,
  ) {
    this.addressLink = environment.shopAddress.link;
  }

  ngOnInit(): void {
  this.informationService.getFrontParams().pipe(
          takeUntil(this.destroySubject),
        )
          .subscribe(
            (res: any) => {
              let booksReturnHtml = res.results.find ((value:any) =>  value.name == 'booksReturn')?.value;
              this.booksReturn =  this.informationService.getSanitizeString(booksReturnHtml);

              let shopAddressHtml  = res.results.find ((value:any) =>  value.name == 'address')?.value;
              this.shopAddress =  this.informationService.getSanitizeString(shopAddressHtml);

            })

  }



  ngOnDestroy() {
    this.destroySubject.next();
  }

}




